export default __webpack_public_path__ + "static/logo-sm-b0d8ef17106e3896e607eac8a069ee83.png";